import {
  BulletItemModel,
  BulletListing,
} from '@components/_Revamp/BulletListing';
import Typography from '@components/_Revamp/Typography';
import { styled } from '@linaria/react';
import React, { forwardRef } from 'react';
import { AnswerButtonGroup } from './AnswerButtonGroup';

const QuestionFiveDescription = styled.div`
  a {
    cursor: pointer;
    color: #883e89;
    font-weight: 600;
  }
`;

const HelpListContainer = styled.div`
  margin-bottom: 80px;
  margin-left: 0px;
`;

const Title = styled.div`
  margin-bottom: 24px;
`;

const HelpRequiredContainer = styled.div`
  display: flex;
  display: none;
  flex-direction: column;
  align-items: center;
  max-width: 588px;
  opacity: 0;
  margin: 200px auto 0px auto;
  @media screen and (min-width: 1250px) {
    margin: 150px auto 50px auto;
  }
`;

interface QuestionModel {
  question: string;
  description?: BulletItemModel[];
}

const q1: QuestionModel = {
  question: 'Have you ever',
  description: [
    {
      text:
        'had any conditions for which you are on medication for more than 14 days, require regular medical treatment or follow up',
    },
    { text: 'had recurring symptoms yet to seek medical advice' },
    {
      text:
        'needed the assistance of another person or mechanical aids to perform your daily activities',
      highlightText: ['daily activities'],
      tooltipContent: (
        <p>
          <span>Daily activities</span> refers to washing, dressing, feeding,
          toileting, walking or moving around, or transferring.
        </p>
      ),
    },
    {
      text:
        'experienced a drop in your ability to carry on with your domestic way of living or social activities in the last 12 months',
      highlightText: ['domestic way','of living or social activities'],
      tooltipContent: (
        <p>
          <span>Domestic way of living or social activities</span> refers to
          housework, preparing meals, shopping for groceries or personal needs,
          using public transport.
        </p>
      ),
    },
  ],
};

const httSelection: QuestionModel = {
  question:
    "Have you done predictive genetic test on Huntington's disease (HTT)?",
};

const questionList: { [key:string] : QuestionModel } = {
  q1,
};

export interface HelpResuiredProps {
  name: string;
  values?: string;
  onComplete: (questionName: string, answer: string) => void;
}
export const HelpRequired = forwardRef<HTMLDivElement, any>(
  ({ name, values, onComplete }: HelpResuiredProps, ref) => {
    const question: QuestionModel = questionList[name];

    const ButtonGroup_PickaAnswer = (answer: string) => {
      onComplete(name, answer);
    };

    return (
      <HelpRequiredContainer ref={ref}>
        <Title>
          <Typography variant="title" align="center">
            {question.question}
          </Typography>
        </Title>
        <HelpListContainer>
          {question.description && (
            <BulletListing bulletList={question.description} />
          )}
        </HelpListContainer>
        <AnswerButtonGroup
          values={values}
          onPickaAnswer={ButtonGroup_PickaAnswer}
        />
      </HelpRequiredContainer>
    );
  }
);
